'use client';

import { AppImageClient } from '@components/appImage';
import { Button } from '@components/button';
import { Card } from '@components/card';
import { CaseSliderCard } from '@components/casesSlider';
import { Typography } from '@components/typography';
import { memo } from 'react';

import { CardLinkWrapper } from './CardLinkWrapper';

export const CaseCardMobile = memo(({ card }: { card: CaseSliderCard }) => {
  return (
    <CardLinkWrapper card={card}>
      <Card className="relative flex flex-col gap-4 p-4" rounded="18">
        <div className="relative h-[236px] w-full overflow-hidden rounded-[12px]">
          {card.imageData ? (
            <AppImageClient
              {...card.imageData}
              alt={card.alt}
              className="object-cover"
            />
          ) : (
            // См. комментарий в CaseCardWeb: клиентская загрузка кейсов
            <img
              src={card.img}
              alt={card.alt}
              className="h-full w-full object-cover"
            />
          )}
        </div>
        {card.tags?.length > 0 && (
          <div className="absolute top-[28px] right-[28px] left-[28px] flex flex-wrap gap-2">
            {card.tags.map((tag, index) => (
              <div
                key={index}
                className="bg-custom-surface-contrast-low h-fit rounded-xl px-3 py-2 text-sm leading-4 font-medium backdrop-blur-2xl max-sm:text-[14px]"
              >
                {tag}
              </div>
            ))}
          </div>
        )}
        <div className="flex flex-col gap-3">
          {card.chips?.length > 0 && (
            <div className="flex flex-wrap gap-3 max-sm:gap-2">
              {card.chips.map((chip, index) => (
                <div key={index} className="flex items-center gap-1">
                  <div className="h-2 w-2 rounded-[100%] bg-[#fff]/64" />
                  <Typography
                    variant="text-s"
                    className="text-text-base-secondary flex items-center whitespace-nowrap"
                  >
                    {chip}
                  </Typography>
                </div>
              ))}
            </div>
          )}
          <div className="flex flex-col gap-2">
            <Typography
              variant="heading-s"
              className="line-clamp-2 overflow-hidden"
            >
              {card.label}
            </Typography>
            <Typography
              variant="text-m"
              className="text-text-base-secondary line-clamp-4 overflow-hidden"
            >
              {card.description}
            </Typography>
          </div>
          {card.urlArticle && (
            <Button
              className="mt-5 hidden justify-center px-4 max-sm:flex"
              variant="secondary"
              ariaLabel="Посмотреть кейс"
              spacing="normal"
            >
              <div className="g-1 flex">Посмотреть кейс</div>
            </Button>
          )}
        </div>
      </Card>
    </CardLinkWrapper>
  );
});

CaseCardMobile.displayName = 'CaseCardMobile';
